import { render, staticRenderFns } from "./Campus.vue?vue&type=template&id=5fc6a049"
import script from "./Campus.vue?vue&type=script&lang=js"
export * from "./Campus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc6a049')) {
      api.createRecord('5fc6a049', component.options)
    } else {
      api.reload('5fc6a049', component.options)
    }
    module.hot.accept("./Campus.vue?vue&type=template&id=5fc6a049", function () {
      api.rerender('5fc6a049', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/Campus.vue"
export default component.exports